import { Flags, ValueOfKey } from '../../utils-types';

export const GO_HIGH_LEVEL_ACCOUNT_STATUS = {
  ACTIVE: 'ACTIVE',
  NOT_AVAILABLE: 'NOT_AVAILABLE',
} as const;

export type GoHighLevelAccountStatus = ValueOfKey<typeof GO_HIGH_LEVEL_ACCOUNT_STATUS>;
export type GoHighLevelAccountStatusFlags = Flags<GoHighLevelAccountStatus>;
